export default ['#750B1C', '#004EBC', '#8764B8', '#0B6A0B', '#A4262C', '#0078DA'];
